import {
  AddressDetails,
  FlowQuestionId,
  HeraldAddress,
  heraldMailingAddressQuestionIds,
  heraldPrimaryAddressQuestionIds,
} from '@common/types';

import { formatAddress } from '@common/utils';

export const flowStaticPrimaryAddressQuestionIds = [FlowQuestionId.PrimaryAddress];
export const primaryAddressQuestionIds = [...heraldPrimaryAddressQuestionIds, ...flowStaticPrimaryAddressQuestionIds];

export const flowStaticMailingAddressQuestionIds = [FlowQuestionId.MailingAddress];

export const mailingAddressQuestionIds = [...heraldMailingAddressQuestionIds, ...flowStaticMailingAddressQuestionIds];

export const allAddressQuestionIds = [...primaryAddressQuestionIds, ...mailingAddressQuestionIds];

export const mapFormAddressToAddress = (addressFromValue?: HeraldAddress): AddressDetails => {
  if (!addressFromValue) {
    return { formattedAddress: '' };
  }
  const structuredAddress: Omit<AddressDetails, 'formattedAddress'> = {
    line1: addressFromValue.line1,
    line2: addressFromValue.line2,
    city: addressFromValue.city,
    postalCode: addressFromValue.postal_code,
    state: addressFromValue.state,
    country: addressFromValue.country_code,
  };
  return {
    ...structuredAddress,
    formattedAddress: formatAddress(addressFromValue),
  };
};
